// src/app/[lang]/shop/carpets/[titleAtURL]/BuyNowBtn.jsx

'use client'

import {useCart} from '@/contexts/Cart.context';
import {useRouter} from 'next/navigation';


export default function BuyNowBtn({productObj, isSold, lang, dict}){

  const router = useRouter();
  const { addItemToCart } = useCart();

  const handleBuyNow = () => {
    addItemToCart(productObj);
    void router.push(`/${lang}/cart`);
  }

  return <button disabled={isSold} className={'btn-std btn-md lift-on-hover'} onClick={handleBuyNow} style={{marginBlockStart: 0, gridArea: 'buy-btn', justifySelf: 'end', marginRight: '0', blockSize: '2.4rem'}} type={'button'}>{dict.buyNow}</button>
}
